import React, { useState, useRef } from "react";
import styles from "./styles.module.scss";
import ChargebackList from "../ChargebackList";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import Download from "../../../../assets/svg/icons/common/Download";
import useDomainStore from "../../../../stores/domain";

function ChargebackTabs() {
  const { isKurvDomain } = useDomainStore();
  const [activeTab, setActiveTab] = useState("all");
  const chargebackListRef = useRef(null);

  const tabs = [
    { id: "all", label: "All processors" },
    // { id: "stripe", label: "Stripe" },
    // { id: "clover", label: "Clover" },
    // { id: "adyen", label: "Adyen" }
  ];

  const handleDownloadClick = () => {
    if (chargebackListRef.current) {
      chargebackListRef.current.triggerExport();
    }
  };

  return (
    <div className={`${styles.container} ${isKurvDomain ? styles.kurv_theme : ""}`}>
      <div className={styles.header}>
        <div className={styles.tabs}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`${styles.tab} ${activeTab === tab.id ? styles.active : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className={styles.actions}>
          <ButtonIcon
            bgColor="#EDEDF4"
            onClick={handleDownloadClick}
          >
            <Download />
            Download
          </ButtonIcon>
        </div>
      </div>     
      <ChargebackList ref={chargebackListRef} processor={activeTab} />
    </div>
  );
}

export default ChargebackTabs; 